import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { $cardStore } from '@lib/store';
import { BlockReason } from '@shared/api';
import { BaseInput, Button, Modal, Radio, Text } from '@shared/widgets';

const REASON_OPTIONS = [
  { text: 'sidebar.modals.report.reasons.lost', value: BlockReason.LOST },
  { text: 'sidebar.modals.report.reasons.stolen', value: BlockReason.STOLEN },
];

interface IForm {
  reason: BlockReason;
  location?: string;
}
const DEFAULT_VALUES: IForm = { reason: BlockReason.LOST, location: '' };

interface ReportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ReportModal = (props: ReportModalProps) => {
  const cardStore = useUnit($cardStore.store);

  const { t } = useTranslation('card');

  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });

  const closeHandler = () => {
    props.onClose();
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    await $cardStore.events.reportLostStolen({ cardId: cardStore.data!.cardId, blockReason: data.reason, locations: data.location });
    closeHandler();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} loading={cardStore.actionLoading} title={t('sidebar.modals.report.title')}>
      <form className='flex flex-col gap-5' noValidate onSubmit={handleSubmit(submitHandler)}>
        <div>
          <Text className='mb-2' size='sm'>
            {t('sidebar.modals.report.placeholders.fraudReason')}
          </Text>
          <Controller
            name='reason'
            control={control}
            render={({ field: { value, onChange } }) => (
              <Radio
                orientation='horizontal'
                options={REASON_OPTIONS.map((option) => ({ ...option, text: t(option.text) }))}
                value={value}
                onChange={onChange}
              />
            )}
          />
        </div>
        <Controller
          name='location'
          control={control}
          render={({ field }) => <BaseInput {...field} placeholder={t('sidebar.modals.report.placeholders.fraudLocation')} />}
        />
        <Button className='mt-1' fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('sidebar.modals.report.buttons.report')}
        </Button>
      </form>
    </Modal>
  );
};
